import React, { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Save, Phone, MessageCircle, Mail, MapPin, User, Clock } from "lucide-react";

export default function MitraIdentitas() {
  const [store, setStore] = useState(null);
  const [form, setForm] = useState({ pic_name: "", pic_wa: "", pic_email: "", contact: "", address: "", opening_hours: "", notes: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/mitra/store-details").then((r) => {
      setStore(r.data);
      setForm({
        pic_name: r.data.pic_name || "",
        pic_wa: r.data.pic_wa || "",
        pic_email: r.data.pic_email || "",
        contact: r.data.contact || "",
        address: r.data.address || "",
        opening_hours: r.data.opening_hours || "",
        notes: r.data.notes || "",
      });
    });
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/mitra/store-details", form);
      setStore(data.store);
      setForm({
        pic_name: data.store.pic_name || "",
        pic_wa: data.store.pic_wa || "",
        pic_email: data.store.pic_email || "",
        contact: data.store.contact || "",
        address: data.store.address || "",
        opening_hours: data.store.opening_hours || "",
        notes: data.store.notes || "",
      });
      toast.success("Identitas toko diperbarui");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  if (!store) return <div className="p-8 text-slate-500">Memuat...</div>;

  return (
    <>
      <PageHeader title="Identitas Retail" subtitle={`Kelola info kontak dan PIC untuk ${store.name}`} testId="page-mitra-identitas"/>

      <Card className="p-6 border border-[var(--hotto-border)] rounded-md max-w-3xl">
        <div className="mb-4">
          <div className="overline mb-1">Nama Toko</div>
          <div className="text-xl font-bold" style={{fontFamily:'Outfit'}}>{store.name}</div>
          <div className="text-xs text-slate-500 mt-1">Nama toko hanya bisa diubah oleh supplier.</div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="flex items-center gap-1"><User className="w-3 h-3"/> Nama PIC / Penanggung Jawab</Label>
            <Input value={form.pic_name} onChange={(e) => setForm({ ...form, pic_name: e.target.value })} placeholder="mis. Ibu Rina Aeon BSD" data-testid="input-pic-name"/>
          </div>
          <div>
            <Label className="flex items-center gap-1"><MessageCircle className="w-3 h-3 text-emerald-600"/> No. WhatsApp</Label>
            <Input value={form.pic_wa} onChange={(e) => setForm({ ...form, pic_wa: e.target.value })} placeholder="mis. 08123456789" data-testid="input-pic-wa"/>
          </div>
          <div>
            <Label className="flex items-center gap-1"><Mail className="w-3 h-3"/> Email</Label>
            <Input type="email" value={form.pic_email} onChange={(e) => setForm({ ...form, pic_email: e.target.value })} placeholder="pic@toko.com" data-testid="input-pic-email"/>
          </div>
          <div>
            <Label className="flex items-center gap-1"><Phone className="w-3 h-3"/> No. Telepon Toko</Label>
            <Input value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} data-testid="input-contact"/>
          </div>
          <div className="md:col-span-2">
            <Label className="flex items-center gap-1"><MapPin className="w-3 h-3"/> Alamat Lengkap Toko</Label>
            <Textarea rows={2} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} data-testid="input-address"/>
          </div>
          <div className="md:col-span-2">
            <Label className="flex items-center gap-1"><Clock className="w-3 h-3"/> Jam Operasional</Label>
            <Input value={form.opening_hours} onChange={(e) => setForm({ ...form, opening_hours: e.target.value })} placeholder="mis. Senin-Minggu 10:00-22:00 WIB" data-testid="input-hours"/>
          </div>
          <div className="md:col-span-2">
            <Label>Catatan Lain / Info Tambahan</Label>
            <Textarea
              rows={3}
              value={form.notes}
              onChange={(e) => setForm({ ...form, notes: e.target.value })}
              placeholder="mis. Barcode toko, area rak khusus, kontak backup, dll"
              data-testid="input-store-notes"
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <Button onClick={save} disabled={busy} className="bg-[var(--hotto-primary)] hover:bg-[var(--hotto-primary-hover)]" data-testid="btn-save-identitas">
            <Save className="w-4 h-4 mr-2"/> {busy ? "Menyimpan..." : "Simpan Perubahan"}
          </Button>
        </div>
      </Card>
    </>
  );
}
